<ncp-table #pastIllness [(options)]="options"></ncp-table>
